import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  BsInstagram,
  BsWhatsapp,
  BsTelephone,
  BsEnvelope,
  BsGeoAlt,
} from "react-icons/bs";
import { FaTiktok } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-black text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-2xl font-serif font-bold text-white"
              >
                Acquwaa Naturals
              </Link>
              <p className="text-gray-600 max-w-sm">
                Premium natural hair care products designed to nourish and
                enhance your natural beauty.
              </p>
            </div>
            <div className="flex space-x-4">
              {[
                { icon: BsInstagram, href: "https://www.instagram.com/acquwaa_naturals_?igsh=MWd0ZTV6djAxbWtjYw==" },
                { icon: FaTiktok, href: "https://www.tiktok.com/@acquwaanaturals?_t=ZM-8uUOlX09bnx&_r=1" },
                {
                  icon: BsWhatsapp,
                  href: "https://wa.me/233246099153",
                },
              ].map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#DB5461] transition-colors duration-300"
                >
                  <social.icon className="h-5 w-5" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#DB5461]">
              Quick Links
            </h3>
            <ul className="space-y-4">
              {[
                { name: "Products", href: "/products" },
                { name: "About Us", href: "/about" },
                { name: "Hair Quiz", href: "/hair-quiz" },
                { name: "Contact", href: "/contact" },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-600 hover:text-[#DB5461] transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#DB5461]">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3 text-gray-400 group">
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-[#DB5461] transition-colors duration-300"
                >
                  <BsGeoAlt className="h-4 w-4" />
                </motion.div>
                <span>GE-238-1051</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400 group">
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-[#DB5461] transition-colors duration-300"
                >
                  <BsTelephone className="h-4 w-4" />
                </motion.div>
                <span>+233 24 609 9153</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400 group">
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-[#DB5461] transition-colors duration-300"
                >
                  <BsEnvelope className="h-4 w-4" />
                </motion.div>
                <span>acquwaanaturals@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#DB5461]">
              Business Hours
            </h3>
            <ul className="space-y-4 text-gray-400">
              <li>Monday - Friday: 9am - 6pm</li>
              <li>Saturday: 10am - 4pm</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#DB5461]/20">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between text-gray-400 text-sm">
            <p>
              © {new Date().getFullYear()} Acquwaa Naturals. All rights
              reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/shipping-policy" className="hover:text-[#DB5461]">
                Shipping Policy
              </Link>
              <Link to="/returns-exchanges" className="hover:text-[#DB5461]">
                Returns & Exchanges
              </Link>
              <Link to="/faq" className="hover:text-[#DB5461]">
                FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
